/**
 * Authentication layout component
 * Provides consistent layout for login, register, and other auth pages
 */
import React from 'react';
import { Outlet } from 'react-router-dom';
import {
  Box,
  Container,
  Typography,
} from '@mui/material';

/**
 * Authentication layout component
 * @returns JSX Element
 */
const AuthLayout: React.FC = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        bgcolor: 'background.default',
      }}
    >
      {/* Main Content Area - Centered */}
      <Box
        component="main"
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexGrow: 1,
          py: 4,
        }}
      >
        <Outlet />
      </Box>

      {/* Footer */}
      <Box
        component="footer"
        sx={{
          py: 3,
          px: 2,
          mt: 'auto',
        }}
      >
        <Container maxWidth="sm">
          <Typography variant="body2" color="primary" align="center">
            © {new Date().getFullYear()} World Health Organization.All rights reserved.
          </Typography>
        </Container>
      </Box>
    </Box>
  );
};

export default AuthLayout;
